'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
var tooltip$1 = require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
var tooltip = require('../../../../styles/styled-components/tooltip.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseHoverTooltip = (props)=>{
    const { children , className , look , position , text , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement("span", _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-tooltip': true,
            'bf-tooltip__hover': true,
            [`bf-tooltip__hover--${look}`]: true,
            [`bf-tooltip__hover--${position}`]: true,
            [`${className}`]: !!className
        }),
        "data-tooltip": text
    }), children);
};
const Tooltip = styled__default.default(BaseHoverTooltip)`
  ${tooltip.baseTooltipStyle}
  ${({ look , position  })=>tooltip.getTooltipPosition({
        look,
        position
    })}
`;
/**
 * A tooltip that only display on cursor `:hover`. This will not display on touch devices.
 * Because of CSS tooltip limitations, text should be kept short.
 *
 * IMPORTANT: This component is NOT considered accessible and should only be used
 * for decoration (to display non-critical information). If you're adding a tooltip
 * to a `<button>`, `<input>`, or other focusable element, use `<StandardTooltip>` instead.
 * If you need lengthy supplemental information, consider using a `<StandardPopout>`.
 *
 * Child elements should have appropriate `aria-label`, `title`, `<OnlyForScreenReader>`, or visible text.
 *
 * @param props HoverTooltipProps
 * @returns FunctionComponent<HoverTooltipProps>
 */ const HoverTooltip = (props)=>{
    const { look =tooltip$1.TooltipLooks.Default , position =tooltip$1.TooltipPositions.Top  } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Tooltip, _extends({}, props, {
        look: look,
        position: position
    })));
};

exports.HoverTooltip = HoverTooltip;
//# sourceMappingURL=hover-tooltip.js.map
